import React from "react";
import "../../styles/uploadimage.css";
import "../../styles/static-content.css";


export default class HowToSell extends React.Component {

    constructor(props) {
        super(props);

    }

    render() {

        return (

            <div className="main-hts-section">

                <div className="main-bg-hts">
                    <h1 className="plat-main-heading">HOW TO SELL</h1>
                    <div className="line-2"></div>
                </div>

                <div className="bg-grey">
                    <div className="container">
                        <div className="col-md-12">
                            <div className="row">
                                <h1 className="selling-on-masterpie">

                                    Selling on YourMasterpieces is very simple. We bring you and the buyer together. You
                                    both agree to make the transaction. You send the artwork to the buyer on receiving a
                                    credit note from us and get paid when they get it.
                                </h1>

                                <div className="line-5"></div>

                                <h2 className="we-strive-towards-ar">
                                    We strive towards artist empowerment and are here to ensure every artist gets the
                                    chance
                                    to showcase their art on a global scale.
                                </h2>


                                <div className="main-block-hts">

                                    <h2 className="section-title">HOW IT WORKS</h2>
                                    <div className="line-2"></div>

                                    <div className="row card-section-hts eq-height">
                                        <div className="col-md-4">
                                            <div className="package-grid-item">
                                                <div className="image-card">
                                                    <img className="hts-card-image"
                                                         src={require('../../assets/approve_ship.png')}/>
                                                </div>

                                                <div className="number-grid black">
                                                    <h2 className="number-text">1</h2>
                                                </div>

                                                <div className="content-card">
                                                    <h4 className="card-heading">You approve & ship</h4>
                                                    <p className="card-desc-text">
                                                       Buyers places buy request on your artwork, you agree to sell and ship the artwork.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <div className="package-grid-item">
                                                <div className="image-card">
                                                    <img className="hts-card-image"
                                                         src={require('../../assets/credits_icon.png')}/>
                                                </div>

                                                <div className="number-grid black">
                                                    <h2 className="number-text">2</h2>
                                                </div>

                                                <div className="content-card">
                                                    <h4 className="card-heading">YOU RECEIVE A CREDIT NOTE </h4>
                                                    <p className="card-desc-text">
                                                        You will receive a credit note for the amount you agreed to sell
                                                        the
                                                        art for in your wallet.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <div className="package-grid-item">
                                                <div className="image-card">
                                                    <img className="hts-card-image"
                                                         src={require('../../assets/cash_icon.png')}/>
                                                </div>

                                                <div className="number-grid black">
                                                    <h2 className="number-text">3</h2>
                                                </div>

                                                <div className="content-card">
                                                    <h4 className="card-heading">CREDIT CONVERTED TO CASH </h4>
                                                    <p className="card-desc-text">
                                                        Credit is converted to cash as soon as the buyer receives the
                                                        artwork.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div className="main-block-hts">

                                    <h2 className="section-title">QUESTIONS</h2>
                                    <div className="line-2"></div>

                                    <div className="col-md-12">
                                        <div className="row pt-25">
                                            <div className="col-md-8">
                                                <div className="package-grid-item grid-2">
                                                    <h4 className="card-heading-second">HOW TO JOIN</h4>
                                                    <p className="card-desc-text-second">
                                                        We know how everyone dislikes long and complicated sign up
                                                        processes. We dislike them too! While designing the signup
                                                        process for YourMasterpieces your comfort and ease was our
                                                        biggest priority and we tried to keep it to as few steps as
                                                        possible.

                                                    </p>

                                                    <h2 className="grey-text-bold link mb-15 mt-25">Click on Sign Up</h2>

                                                    <p className="card-desc-text-second mb-25 pb-35">
                                                        Fill in basic details like your full name, account name, city,
                                                        country of residence, email and set your password to complete
                                                        your profile, and you are done!
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="package-grid-item grid-2">
                                                    <h4 className="card-heading-second">SELLER TERMS OF USE</h4>
                                                    <p className="card-desc-text-second">We are an open platform but we
                                                        need
                                                        you to keep in mind and follow the <a className="agree-link pl-0" href="/terms-and-conditions"  style={{color : "#BEA57C"}}>Terms and Conditions</a> listed here.
                                                    </p>
                                                </div>
                                                <div className="package-grid-item grid-2">
                                                    <h4 className="card-heading-second">GET HELP</h4>
                                                    <p className="card-desc-text-second">
                                                        Having trouble or need some help? Get in touch with your queries
                                                        at <a className="link"
                                                              href="mailto:support@yourmasterpieces.com">support@yourmasterpieces.com</a>
                                                    </p>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                </div>


                            </div>
                        </div>
                    </div>

                </div>
            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/static/how-to-sell.js